import { keepPreviousData } from '@tanstack/react-query';
import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';
import type { LeadListParams, LeadPipelineSummaryEntry } from '@/types/lead';

/**
 * NOT-514 #2: the board's truthful per-stage count + summed value for the
 * current filter set. The backend groups across every stage (a `stage` filter
 * is ignored so each column still gets its own aggregate) and applies the same
 * filters + permission scope as the list, so these numbers agree with the
 * cards. Board headers read these instead of counting the paginated cards they
 * happen to have loaded. `keepPreviousData` keeps the last totals on screen
 * while a filter change refetches.
 */
export function useLeadPipelineSummary(
  params: LeadListParams = {},
  options?: { enabled?: boolean },
) {
  return useApiQuery<LeadPipelineSummaryEntry[]>({
    queryKey: leadKeys.pipelineSummary(params),
    queryFn: () =>
      apiGet<LeadPipelineSummaryEntry[]>(operationsClient, leadEndpoints.pipeline(), {
        params: params as Record<string, unknown>,
      }),
    placeholderData: keepPreviousData,
    showErrorToast: false,
    enabled: options?.enabled,
  });
}
